/**
 * Weather Debug Utilities
 * Utility functions for debugging and clearing weather cache
 */

export const clearWeatherCache = (): void => {
  try {
    // Clear weather-related localStorage items
    const weatherKeys = [
      'weather-location-preference',
      'weather-saved-city',
      'weather-location-timestamp',
      'weather-saved-locations',
      'weather-coordinates',
      'weather-store'
    ];

    weatherKeys.forEach(key => {
      localStorage.removeItem(key);
    });

    // Clear weather cache from memory
    if (typeof window !== 'undefined' && (window as any).weatherCache) {
      (window as any).weatherCache.clear();
    }

    // Weather cache cleared silently
  } catch (error) {
    console.error('Error clearing weather cache:', error);
  }
};

export const getWeatherDebugInfo = (): object => {
  try {
    const debugInfo = {
      localStorage: {
        locationPreference: localStorage.getItem('weather-location-preference'),
        savedCity: localStorage.getItem('weather-saved-city'),
        coordinates: localStorage.getItem('weather-coordinates'),
        timestamp: localStorage.getItem('weather-location-timestamp'),
        savedLocations: localStorage.getItem('weather-saved-locations'),
        store: localStorage.getItem('weather-store')
      },
      geolocation: {
        supported: 'geolocation' in navigator,
        permissions: navigator.permissions ? 'available' : 'not available'
      },
      network: {
        online: navigator.onLine,
        userAgent: navigator.userAgent
      },
      url: {
        current: window.location.href,
        search: window.location.search,
        hash: window.location.hash
      }
    };

    console.log('Weather Debug Info:', debugInfo);
    return debugInfo;
  } catch (error) {
    console.error('Error getting weather debug info:', error);
    return { error: error.message };
  }
};

export const testWeatherAPI = async (): Promise<void> => {
  try {
    console.log('Testing weather API connection...');
    
    // Test Open-Meteo API directly
    const response = await fetch('https://api.open-meteo.com/v1/forecast?latitude=-6.2088&longitude=106.8456&current=temperature_2m,weather_code');
    
    if (response.ok) {
      const data = await response.json();
      console.log('Weather API test successful:', data);
    } else {
      console.error('Weather API test failed:', response.status, response.statusText);
    }
  } catch (error) {
    console.error('Weather API test error:', error);
  }
};

// Make functions available globally for debugging
if (typeof window !== 'undefined') {
  (window as any).weatherDebug = {
    clearCache: clearWeatherCache,
    getDebugInfo: getWeatherDebugInfo,
    testAPI: testWeatherAPI
  };
}